(function () {
    const RELOAD_STORAGE_KEY = 'vite:chunk-reload';
    const RELOAD_GUARD_TIME_MS = 30_000;

    function showUpdateError(error) {
        console.error('The application could not load the latest version.', error);

        window.alert('Uma nova versão da aplicação foi publicada, mas não foi possível carregá-la. Atualize a página manualmente.');
    }

    window.addEventListener('vite:preloadError', function (event) {
        event.preventDefault();

        const now = Date.now();
        const lastReload = Number(
            sessionStorage.getItem(RELOAD_STORAGE_KEY) || 0
        );

        console.error('Failed to load a Vite chunk.', event.payload);

        if (now - lastReload < RELOAD_GUARD_TIME_MS) {
            sessionStorage.removeItem(RELOAD_STORAGE_KEY);
            showUpdateError(event.payload);
            return;
        }

        sessionStorage.setItem(RELOAD_STORAGE_KEY, String(now));

        window.location.reload();
    });

    window.setTimeout(function () {
        sessionStorage.removeItem(RELOAD_STORAGE_KEY);
    }, RELOAD_GUARD_TIME_MS);
}())

